import { Temporal } from '@js-temporal/polyfill';
import { CoordinatorService } from './coordinator.service';
import { TableCell } from './table-cell';
import { TableRowInstance } from './table-row-instance';
import { TABLE_TYPE } from './table-instance';

export class TableCellInstance {
    private _isEditOn = false;

    private _editText = '';
    private _editValue: string[] | boolean = false;

    constructor(
        private coords: CoordinatorService,
        public tblri: TableRowInstance,
        public tc: TableCell,
    ) {}

    submitIsDisabled() {
        if (this.tc.mustHaveValue && !this._editText?.trim()) return true;
        return false;
    }

    private _refresh() {
        this.coords.display$.markForCheck();
    }

    public get editText(): string {
        return this._editText;
    }

    public set editText(value: string) {
        if (value === undefined) return;
        this._editText = value;
        this.tbli.isAutoconfirm && this.tbli.input.set(this.tc.tag, this.editText);

        this._manualInform();
    }

    private _manualInform() {
        this.coords.display$.manualTableChange(this.input);
    }

    public get editValue(): any {
        if (!this._editValue) {
            if (Array.isArray(this.value)) this._editValue = Array.from(this.value);
            else this._editValue = this.value;
        }
        return this._editValue;
    }

    public set editValue(value: any) {
        this._editValue = value;
        this._manualInform();
    }

    exportParams() {
        return [this.coords.text(this.tc.label), this.value || ''];
    }

    get input() {
        return this.tblri.input;
    }

    get value() {
        let v: any;
        if (this.tc.tag === 'id') {
            v = this.input.shortID || this.input.id;
        } else {
            v = this.input.get(this.tc.tag);
        }
        if (this.tc.searchTag) {
            const h$ = this.coords.highlight$;
            if (Array.isArray(v)) {
                if (!v.length) return '';
                v = v.map((x) => h$.run(x, this.tc.searchTag!));
                if (this.tc.searchTag === 'authorLs')
                    this.coords.utils$.highlightFirstLastAuthor(v);
            } else v = h$.run(v, this.tc.searchTag);
        }
        return v;
    }

    public get isEditOn(): boolean {
        return this.tbli.isEditOn || this._isEditOn;
    }
    public set isEditOn(value: boolean) {
        this._isEditOn = value;

        this._refresh();
    }

    get isEmpty() {
        const v = this.value;
        if (v === undefined) return true;
        if (Array.isArray(v)) return !v.length;

        if (typeof v == 'number') return false;

        if (typeof v == 'string') return !v.trim();
        try {
            Temporal.Instant.from(v);
            return false;
        } catch (e) {}

        return true;
    }

    get tbli() {
        return this.tblri.tbli;
    }

    set directValueChange(value: any) {
        this.input.set(this.tc.tag, value);
    }

    confirmChanges() {
        if (this.tc.type == 'boolean' || this.tc.type.endsWith('[]')) {
            this.tbli.input.set(this.tc.tag, this.editValue);
        } else {
            this.tbli.input.set(this.tc.tag, this.editText);
        }
    }

    initEdit() {
        if (this.tc.type == 'boolean') {
            this.editValue = this.input.get(this.tc.tag);
        } else {
            this.editText = this.input.get(this.tc.tag);
        }
    }
}
